import { gql } from '@apollo/client';

export default gql`
  mutation UpdateSeatsByToken($token: String!, $seats: Int!, $subscriptionId: MongoID!) {
    updateSeatsByToken(token: $token, seats: $seats, subscriptionId: $subscriptionId) {
      current
      pricePerSeat
      period
      total
      history {
        date
        quantity
        amount
      }
    }
  }
`;
